/**********************************************************
Fertilizer List: Lists all fert apps
2/13/20
**********************************************************/
import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';

const propTypes = {
  FertilizerAppList: PropTypes.array,
  onClick: PropTypes.func
};

const FertilizerAppList = ({ fertAppList, employees, onClick }) => {
  if (!fertAppList) return <span>No Applications Available</span>;
  return (
    <div className="card">
      <ul className="collection">
        {
          fertAppList.map((c) => (
            <li key={c.fertAppId} className="collection-item chem-list-item"
              onClick={() => onClick({ formId: 'fertilizer-application-form', app: c, employees })}>
              <span><b>{ moment(c.date).format('MM/DD/YYYY') }</b></span><br />
              <div className="fert-flex-list">
                {
                  c.fertilizerApplied.map((f) => {
                    return (
                      <span key={`${f.id}${Math.random()}`}>
                        { f.field }
                        <span className="icon-shift"><i className={'material-icons'}>{ f.unitOfMeasure === 'tons' ? 'grain' : 'invert_colors' }</i></span>
                      </span>
                    )
                  })
                }
              </div>
            </li>
          ))
        }
      </ul>
    </div>
  );
}

FertilizerAppList.propTypes = propTypes;
export default FertilizerAppList;


/* END */



// WEBPACK FOOTER //
// ./src/cultivation/components/fertilizer/fertilizer_list.js